<template>
  <v-container
    id="usuarioCrear"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="secondary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Crear Nuevo Usuario
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text h-1 font-weight-light">
              Ingresar un correo válido
            </div>
            <v-form ref="form" v-model="valid" lazy-validation v-if="mostrar">
              <v-text-field
                color="secondary"
                v-model="email"
                label="Email *"
                prepend-icon="mdi-face"
                class="mt-10"
                required
                :rules="emailRules"
                :max="70"
              />
              <v-text-field
                class="mb-8"
                v-model="contrasena"
                type="password"
                color="secondary"
                label="Contraseña *"
                prepend-icon="mdi-lock-outline"
                required
                :rules="contrasenaRules"
                :max="25"
              />
              <v-text-field
                class="mb-8"
                v-model="contrasenaConfirmar"
                type="password"
                color="secondary"
                label="Confirmar Contraseña*"
                prepend-icon="mdi-lock-outline"
                required
                :rules="contrasenaConfirmarRules"
                :max="15"
              />
              <div class="body-2 font-weight-light">* Campos Requeridos</div>
              <v-flex class="red--text" v-if="error">{{ error }}</v-flex>
              <pages-btn @click="loader = 'loading', crear()" large :disabled="!valid"   :loading="loading"
              >
                Registrar
              </pages-btn>
            </v-form>

            <v-form ref="form" v-model="valid" lazy-validation v-if="!mostrar">
            <v-text-field
              class="mb-8"
              v-model="codigo_validacion"
            
              color="secondary"
              label="Ingresar código"
              prepend-icon="mdi-lock-outline"
              required
              :rules="contrasenaConfirmarRules"
              :max="15"
           
            />
           
            
            <pages-btn @click="loader = 'loading', validar()" large v-if="!mostrar" :disabled="!valid"   :loading="loading" >
              Validar
            </pages-btn>
            </v-form>
            <v-spacer></v-spacer>
            <v-chip
              class="ma-2"
              color="success"
              outlined
              :to="{ name: 'Login' }"
            >
              <v-icon left> mdi-arrow-left </v-icon>
              Regresar
            </v-chip>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  data() {
    return {
      valid: true,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail requerido",
        (v) => /.+@.+\..+/.test(v) || "Ingresar E-mail válido",
      ],
      contrasena: "",
      contrasenaRules: [
        (v) => !!v || "Contraseña es requerida",
        (v) =>
          (v && v.length > 5) || "Contraseña debe tener minimo 5 caracteres",
        (v) =>
          (v && v.length < 30) || "Contraseña debe tener maximo 30 caracteres",
      ],
      contrasenaConfirmar: "",
      contrasenaConfirmarRules: [
        (v) => !!v || "Contraseña es requerida",
        (v) =>
          (v && v.length > 5) || "Contraseña debe tener minimo 5 caracteres",
        (v) =>
          (v && v.length < 30) || "Contraseña debe tener maximo 30 caracteres",
      ],
      mostrar: true,
      error: null,
      loader: null,
      loading: false,

      codigo_validacion: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      this.loader = null;
    },
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    crear() {
      let me = this;
      me.error = null;
      if (me.contrasena == me.contrasenaConfirmar) {
        console.log("Ingrese a crear ");
        axios
          .post("api/Usuarios/Crear", {
            email: me.email,
            password: me.contrasena,
          })
          .then(function (response) {
          console.log(response.data);
          console.log("valor del unico ");
          console.log(response.data.unico);
          localStorage.setItem("unico", response.data.unico);
          console.log("creo usuario !!");
            me.mostrar = false;
            me.loader=null;
            me.loading=false;
        })
          .catch((err) => {
            //console.log(err.response);
            if (err.response.status == 400) {
              this.error =  "Usuario ya existe en nuestro sistema";
              me.loader=null;
              me.loading=false;
          
            } else {
              this.error = "Ocurrió un error";
              me.loader=null;
              me.loading=false;
            }
          });
      } else {
        this.error = "Contraseñas no coinciden";
        me.loader=null;
            me.loading=false;
      }
    },
    validar() {
      let me = this;
      me.error = null;
     
        console.log("Ingrese a crear ");

        axios
        .put(
          "api/Usuarios/ValidarUsuario",
          {
            email: me.email,
            codigo_validacion: me.codigo_validacion,
            unico:localStorage.getItem("unico")
          }
        )
        .then(function () {
          me.ingresar();
        })
        .catch((err) => {
          console.log("errores catch");
          console.log(err);
          me.loader=null;
            me.loading=false;
        });
    },
    ingresar() {
      this.error = null;
      axios
        .post("api/Usuarios/Login", {
          email: this.email,
          password: this.contrasena,
        })
        .then((respuesta) => {
          return respuesta.data;
        })
        .then((data) => {
          console.log("login !!");
          console.log(data.token);
          localStorage.setItem("email", this.email);
          this.$store.dispatch("guardarToken", data.token);
          this.$router.push({ name: "Dashboard" });
        })
        .catch((err) => {
          //console.log(err.response);
          if (err.response.status == 400) {
            this.error = "Invalid email or password";
          } else if (err.response.status == 404) {
            this.error = "Invalid email or password";
          } else {
            this.error = "Ocurrió un error";
          }
          //console.log(err)
        });
    },
  },
};
</script>

